import { Button, Input, Modal } from 'antd'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
const key = process.env.REACT_APP_AZURE_KEY
const region = process.env.REACT_APP_AZURE_REGION

function DashBoard ({}) {
    const [text1, setText1] = useState("")
    const [text2, setText2] = useState("")
    const [speaker1, setSpeaker1] = useState("")
    const [speaker2, setSpeaker2] = useState("")
  
    function textToVoice(ssml, callback) {
    
        const speechConfig = sdk.SpeechConfig.fromSubscription(key, region);
        const audioConfig = sdk.AudioConfig.fromDefaultSpeakerOutput();
      
        // speechConfig.speechSynthesisLanguage = "en-US";
        // speechConfig.speechSynthesisVoiceName = "en-US-JennyNeural";
        // speechConfig.speechSynthesisOutputFormat =
        //   sdk.SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3;
      
        let synthesizer = new sdk.SpeechSynthesizer(speechConfig, audioConfig);
        // synthesizer.speakTextAsync(
        synthesizer.speakSsmlAsync(
          ssml,
          (result) => {
            if (result.reason === sdk.ResultReason.SynthesizingAudioCompleted && result.audioData.byteLength > 1000) {
              console.log("success")
            } else {
              console.error("Speech synthesis canceled, " + result.errorDetails +
                  "\nDid you set the speech resource key and region values?");
              callback(result.errorDetails,null)
            }
            synthesizer.close();
            synthesizer = null;
          },
          (error) => {
            console.log(error);
            synthesizer.close();
            synthesizer = null;
          }
        );
    
    }

    const kimsF1 = () => {
        const text = text1.replace("{?}",speaker1)

        textToVoice(text, (err, result) => {
            Modal.error({
              title: "음성파일 듣기 에러",
              okText: "확인",
              content: <><div>Azure SDK에서 에러가 발생하여 정상적으로 듣기를 실행하지 못했습니다.</div><div>{err}</div></>

            });
          });
    }
    const kimsF2 = () => {
        const text = text2.replace("{?}",speaker2)

        textToVoice(text, (err, result) => {
            Modal.error({
              title: "음성파일 듣기 에러",
              okText: "확인",
              content: <><div>Azure SDK에서 에러가 발생하여 정상적으로 듣기를 실행하지 못했습니다.</div><div>{err}</div></>
            });
          });
    }
    return (
        <div>
          <div style={{marginBottom:"30px", fontSize:"18px"}}>음성변환 테스트</div>
          <div style={{display:"flex", justifyContent:"center"}}>
              <Button type="primary" onClick={kimsF1}>Kim's Test</Button>
              <Input style={{width:"300px"}} value={speaker1} onChange={(e)=>setSpeaker1(e.target.value)} placeholder='화자'></Input>
          </div>
          <div>
              <Input.TextArea
              style={{width:"80%", minHeight:"200px"}}
              value = {text1}
              onChange={(e)=>setText1(e.target.value)}
              ></Input.TextArea>
          </div>
          <div style={{display:"flex", justifyContent:"center", marginTop:"20px"}}>
              <Button type="primary" onClick={kimsF2}>Kim's Test</Button>
              <Input style={{width:"300px"}} value={speaker2} onChange={(e)=>setSpeaker2(e.target.value)} placeholder='화자'></Input>
          </div>
          <div>
              <Input.TextArea
              style={{width:"80%", minHeight:"200px"}}
              value = {text2}
              onChange={(e)=>setText2(e.target.value)}
              ></Input.TextArea>
          </div>
        </div>
    )
}

export default DashBoard